var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusSemiround = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#126CFC;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "addnewbutton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7318",
    "data-name": "Group 7318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7920",
    "data-name": "Rectangle 7920",
    className: "cls-1",
    width: 19,
    height: 19,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.83,8.5H10.5V5.17a1,1,0,0,0-2,0V8.5H5.17a1,1,0,0,0,0,2H8.5v3.33a1,1,0,0,0,2,0V10.5h3.33a1,1,0,0,0,0-2Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusSemiround);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOSAxOSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMxMjZDRkM7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5hZGRuZXdidXR0b248L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PGcgaWQ9Ikdyb3VwXzczMTgiIGRhdGEtbmFtZT0iR3JvdXAgNzMxOCI+PHJlY3QgaWQ9IlJlY3RhbmdsZV83OTIwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3OTIwIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjQiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xMy44Myw4LjVIMTAuNVY1LjE3YTEsMSwwLDAsMC0yLDBWOC41SDUuMTdhMSwxLDAsMCwwLDAsMkg4LjV2My4zM2ExLDEsMCwwLDAsMiwwVjEwLjVoMy4zM2ExLDEsMCwwLDAsMC0yWiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";